export type IssueCategory =
  | 'duplicates'
  | 'possibleDuplicates'
  | 'poorFilenames'
  | 'emptyFolders'
  | 'emptyFiles'
  | 'systemFiles'
  | 'deepNesting'
  | 'longPaths'
  | 'similarFolders'
  | 'catchAllFolders'
  | 'libraryLimits';

export type IssueSeverity = 'high' | 'medium' | 'low';

/** One problem found by a rule. A group issue (e.g. a duplicate set) lists every affected item. */
export interface IIssue {
  /** Stable within a scan: '{category}:{first affected id}'. */
  id: string;
  category: IssueCategory;
  severity: IssueSeverity;
  /** Plain-language explanation shown to the administrator. */
  message: string;
  fileIds: string[];
  folderIds: string[];
}

export interface IRuleOptions {
  /** Folders deeper than this are flagged. The library root is depth 0. */
  maxDepth: number;
  /** Full server-relative paths longer than this are flagged (SharePoint's hard limit is 400). */
  maxPathLength: number;
  /** Items (files + folders) in one library above which it should be split — a common expert guideline. */
  libraryItemGuideline: number;
  /** Items above which OneDrive sync of the library runs into trouble. */
  syncItemLimit: number;
}

export const DEFAULT_RULE_OPTIONS: IRuleOptions = {
  maxDepth: 5,
  maxPathLength: 350,
  libraryItemGuideline: 100000,
  syncItemLimit: 300000
};

export interface IHealthReport {
  issues: IIssue[];
  byCategory: { [category in IssueCategory]: IIssue[] };
}
